import React from 'react';
import {Text as RNText} from 'react-native';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import Banner from '../Banner';

storiesOf('base', module).add('Banner', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Banner</Heading>
        <Spacer size={16} />
        <RNText>
          There are five values that can be passed to the{' '}
          <Code>alertLevel</Code> prop to style the banner colors.
        </RNText>
        <Spacer size={16} />
        <Banner alertLevel="low">
          <Text>Low emphasis banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'alertLevel="low"'}</Code>
        <Spacer size={16} />
        <Banner alertLevel="info">
          <Text>Info banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'alertLevel="info"'}</Code>
        <Spacer size={16} />
        <Banner alertLevel="important">
          <Text>Important banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'alertLevel="important"'}</Code>
        <Spacer size={16} />
        <Banner alertLevel="success">
          <Text>Success banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'alertLevel="success"'}</Code>
        <Spacer size={16} />
        <Banner alertLevel="error">
          <Text>Error banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'alertLevel="error"'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Competency-themed Banners</Heading>
        <Spacer size={16} />
        <RNText>
          When the <Code>useCompetency</Code> prop is set to true, the
          competency-based theme colors will be used to style the banner.
        </RNText>
        <Spacer size={16} />
        <Banner useCompetency={true}>
          <Text>Competency-themed banner</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'useCompetency={true}'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Vertical Banners</Heading>
        <Spacer size={16} />
        <RNText>
          When the <Code>verticalBanner</Code> prop is set to true, the vertical
          banner will be used. The <Code>alertLevel</Code> prop can be used to
          style the banner colors.
        </RNText>
        <Spacer size={16} />
        <Banner verticalBanner={true} alertLevel="important">
          <Text variant="heading">Vertical Banner Header</Text>
          <Text variant="body">Vertical Banner Body</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'verticalBanner={true}'}</Code>
        <Spacer size={10} />
        <Code>{'alertLevel="important"'}</Code>
        <Spacer size={10} />
        <RNText>
          We can still show the close icon for vertical banners. It's handled by
          passing <Code>bannerClose</Code> prop
        </RNText>
        <Spacer size={16} />
        <Banner
          verticalBanner={true}
          alertLevel="important"
          bannerClose={() => {}}>
          <Text variant="heading">Vertical Banner Header</Text>
          <Text variant="body">Vertical Banner Body</Text>
        </Banner>
        <Spacer size={10} />
        <Code>{'verticalBanner={true}'}</Code>
        <Spacer size={10} />
        <Code>{'alertLevel="important"'}</Code>
        <Spacer size={10} />
        <Code>{'bannerClose={() => {}}'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
